<crowdctrl-list>
  <ion-radio-group [(ngModel)]="currentTheme" (ionChange)="onThemeChange($event.detail.value)">
    @for (theme of availableThemes; track theme.name) {
      <ion-item button (click)="onThemeChange(theme.name)">
        <ion-radio slot="start" [value]="theme.name"></ion-radio>
        <ion-label>
          <crowdctrl-theme-preview-item
            [themeName]="theme.name"
            [showModeLabel]="false"
          ></crowdctrl-theme-preview-item>
        </ion-label>
        @if (getThemeModeLabel(theme.name); as modeLabel) {
          <span slot="end" class="theme-mode-end">{{ modeLabel }}</span>
        }
      </ion-item>
    }
  </ion-radio-group>
</crowdctrl-list>
